
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SystemMaintenance extends Vue {
  constructor() {
    super();
  }
}
